<template>
  <div class="font-wrapper">
    <h3>{{ parseTranslation(CHOOSE_FONT) }}</h3>

    <div>
      <div class="fonts">
        <div class="scroll">
          <button
            v-for="(option, index) in FONTS"
            :key="index"
            :class="{ active: selectedFont === option.value }"
            :style="{
              fontFamily: option.value,
            }"
            @click="selectedFont = option.value"
          >
            {{ option.text }}
          </button>
        </div>
      </div>

      <button class="apply" @click="apply">{{ parseTranslation(APPLY) }}</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { FONTS } from '../chartConfig'

import * as translationFont from './font.translations'

const { default: translations, ...translationKeys } = translationFont

export default {
  name: 'Font',

  props: {
    question_result: {
      required: true,
      type: Object,
    },

    groupCode: {
      required: true,
    },
  },

  data() {
    return {
      FONTS,
      translations,
      ...translationKeys,
      selectedFont: null,
    }
  },

  computed: {
    getFont() {
      return this.question_result?.chartSettings?.font || 'Roboto'
    },
  },

  watch: {
    getFont() {
      this.selectedFont = this.getFont
    },
  },

  methods: {
    ...mapActions(['setChartSettings']),

    apply() {
      this.setChartSettings({
        setting: {
          ...this.question_result?.chartSettings,

          font: this.selectedFont,
        },

        groupCode: this.groupCode,
        questionCode: this.question_result.code,
      })
    },
  },

  created() {
    this.selectedFont = this.getFont
  },
}
</script>

<style lang="scss" scoped>
.font-wrapper {
  padding: 0 10px;
  margin-top: 10px;

  h3 {
    @include chart-config-title;
  }

  > div {
    display: flex;

    .fonts {
      background: $gray-7;
      padding: 5px;
      max-width: 300px;
      width: 100%;
      border-radius: 3px;

      .light & {
        background: $white;
      }

      .scroll {
        height: 200px;
        overflow-y: auto;
        padding-right: 5px;

        &::-webkit-scrollbar {
          width: 8px;
        }

        &::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.1);
          border-radius: 5px;
        }

        &::-webkit-scrollbar-thumb {
          background: $gray-14;
          border-radius: 5px;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: $gray-13;
        }

        button {
          @include tipography(16);
          background: transparent;
          border: none;
          border-radius: 3px;
          outline: none;
          padding: 5px 10px;
          width: 100%;
          text-align: start;

          &:hover {
            text-decoration: underline;
          }

          .light & {
            color: $gray-2;
          }

          &.active {
            background: $blue;
            color: $white;
            text-decoration: none;
          }
        }
      }
    }

    .apply {
      @include primary-general-button;
      @include tipography(14);
      padding: 8px 10px;
      margin: auto 0 0 20px;
      height: fit-content;
      width: 100px;
      letter-spacing: 0.1em;
    }

    @media (max-width: 480px) {
      flex-direction: column;

      .apply {
        margin: 20px 0 0 auto;
      }
    }
  }
}
</style>
